import s from './AuthPlaceholder.module.css'
import img from '../../../../images/atTable.png'
import { useSelector } from 'react-redux'
import Preloader from '@UI/Preloader'
import { checkSettingsStore } from '../../../../services/SettingsStoreUpdateService'
import { useEffect, useState } from 'react'
import { useAsync } from 'react-use'
import { images } from '@/api'
import axios from 'axios'
import setSettingsFromServer from '@/helpers/setSettingsFromServer'

const AuthPlaceholder = ({
  isPreview = false,
  titlePreview,
  subTitlePreview,
  imgPreview,
}) => {
  const titleLoginPage = useSelector(store => store.settings.titleLoginPage);
  const subTitleLoginPage = useSelector(store => store.settings.subTitleLoginPage);
  const imageLoginPage = useSelector(store => store.settings.imageLoginPage);
  const status = useSelector(store => store.settings.status);
  const isLoaded = status == 2;

  const [settingsCustom, setSettingsCustom] = useState(null)

  useEffect(() => {
    if (!isPreview) checkSettingsStore()
    setSettingsFromServer(setSettingsCustom, 'custom')
  }, [])

  const authImage = settingsCustom?.authImage

  const imgState = useAsync(async () => {

    if (isPreview && imgPreview) return imgPreview
    if (authImage)
      return (await images.getAccessCanvas({ imageUrl: `/${authImage}` }))?.data
        ?.contents
    return img
  }, [isPreview, imgPreview, authImage, authImage])

  const imgData = imgState?.value

  return (
    <div className={s.wrapper} style={isLoaded ? {} : { alignSelf: 'center' }}>
      {isLoaded ? (
        <>
          <h2 className={s.title}>
            {isPreview ? titlePreview : titleLoginPage}
          </h2>
          <h3 className={s.subtitle}>
            {isPreview ? subTitlePreview : subTitleLoginPage}
          </h3>
          {imgState.loading ? (
            <Preloader fullScreen="center" />
          ) : (
            <img className={s.img} src={imgData} alt="" />
          )}
        </>
      ) : (
        <div className={s.preloader}>
          <Preloader />
        </div>
      )}
    </div>
  )
}

export default AuthPlaceholder
